import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Link } from '@atlassian/amkt-common';
import React, { Component } from 'react';
export default class FiltersLink extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", event => {
      this.props.onClick(event, {
        newFilters: this.props.newFilters,
        newPerspective: this.props.newPerspective
      });
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(Link, {
      className: this.props.className,
      href: this.props.href,
      onClick: this.onClick
    }, this.props.children);
  }
}
_defineProperty(FiltersLink, "defaultProps", {
  href: '#'
});